import {React} from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from "styled-components";


    
  /* eslint-disable react/prop-types */
function FormDialog({openDialog, handleClose, setFormData, handleYes, formData, text, label, action}){
      const handleChange = (e)=>{
        const {name, value} = e.target
        setFormData({[name]: value})
      }
   

    return (
        <DialogWrapper>

      <Dialog
        open={openDialog}
        PaperProps={{ sx: { width: "40%", } }}
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className="title">
            <span style={{color: '#003a50', fontWeight: "600", fontSize: "1.5rem"}}>{text}</span>
        </DialogTitle>
        
        <DialogContent>
        <input style={{border : "1px solid #B8C8CF", borderRadius: ".5rem", padding:".5rem", width:"100%"}} type={'text'} placeholder={label} name={'category'} onChange={handleChange}/>
        </DialogContent>
        <DialogActions>
          <Button 
              style={{
                backgroundColor: "#003a50",
                padding: ".3rem",
                color: "#ffffff",
                textTransform: "Capitalize"
            }}
           onClick={()=>handleYes(formData)}>{action}</Button>
          <Button 
          style={{
            padding: ".3rem",
            backgroundColor:"#FF7878",
             color:"#ffffff",
             textTransform: "Capitalize"
        }}
          onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
        </DialogWrapper>
    )
}

export const DialogWrapper = styled.div`

.title{
   font-size: 80px;
   border: 1px solid red;
}
	
`;

export default FormDialog